// ANCHOR Model
import { createPropsSelectorModel, createSelector } from 'react-scoped-model';

// ANCHOR API
import { IFormQuestionsResult } from '@lyon/utils/api/results/forms';

interface IProps {
  data?: IFormQuestionsResult;
}

export const FormQuestionItemData = createPropsSelectorModel<IProps>({
  displayName: 'Models.FormQuestionItemData',
});

export const useFormQuestionItemData = createSelector(
  FormQuestionItemData,
  ({ data }) => data,
);

export const useFormQuestionItemDataID = createSelector(
  FormQuestionItemData,
  ({ data }) => data?.id,
);

export const useFormQuestionItemDataName = createSelector(
  FormQuestionItemData,
  ({ data }) => data?.name,
);

export const useFormQuestionItemDataType = createSelector(
  FormQuestionItemData,
  ({ data }) => data?.type,
);

export const useFormQuestionItemDataPosition = createSelector(
  FormQuestionItemData,
  ({ data }) => data?.position,
);

export const useFormQuestionItemDataAnswerCount = createSelector(
  FormQuestionItemData,
  ({ data }) => data?.answerCount,
);
